module.exports = __webpack_public_path__ + "img/sobha-3.a171ae9.webp";